import {Component, Input} from '@angular/core';
@Component({
  selector: 'exg-kpi-circle',
  templateUrl: './exg-kpi-circle.component.html',
  styles: [
  ]
})
export class ExgKpiCircleComponent {

  @Input() caption: string = 'Caption';
  @Input() value: number = 0.75;
  @Input() color: string = '#56ab2f';

  constructor() { }


  get strokestyle(): string {
    return `stroke-dashoffset: calc(333 - (333 * ${this.value}));stroke: ${this.color};`;
  }
  get colorstyle(): string {
    return `color: ${this.color};`;
  }

}
